export var LegalID = function(legalIdData) {
    var legalId = {};
    
    // Constructor
    if (legalIdData) {
        legalId.type = legalIdData.type;
        legalId.value = legalIdData.value;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return legalId;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/legalId.js
// module id = 37
// module chunks = 0